import { Router } from "vue-router";

export function createTitleGuard(router: Router) {
  const name = import.meta.env.VITE_PROJECT_NAME;
  router.afterEach(async (to) => {
    if (to.meta?.title) {
      document.title = `${to.meta.title}-${name}赛事管理系统`;
    } else {
      document.title = `${name}赛事管理系统`;
    }
    return true;
  });
}
